import {useEffect} from 'react';

type RefetchFn = () => Promise<any>;

// Handles refetching for standard onboarding steps and a special case for email
// calendar sync.
export function useOnboardingRefetchListeners(
    refetch: RefetchFn,
    refetchEmailCalendarStatuses: RefetchFn
) {
    useEffect(() => {
        const handleOnboardingStepCompleted = () => {
            refetch();
        };

        const handleEmailCalendarSyncOnboardingStepCompleted = () => {
            refetchEmailCalendarStatuses();
            refetch();
        };

        window.addEventListener('onboarding-step-completed', handleOnboardingStepCompleted);
        window.addEventListener(
            'onboarding-step-completed-email-calendar-sync',
            handleEmailCalendarSyncOnboardingStepCompleted
        );

        return () => {
            window.removeEventListener('onboarding-step-completed', handleOnboardingStepCompleted);
            window.removeEventListener(
                'onboarding-step-completed-email-calendar-sync',
                handleEmailCalendarSyncOnboardingStepCompleted
            );
        };
    }, [refetch, refetchEmailCalendarStatuses]);
}
